<template>
  <div
      id="app"
      :class="{'login-mode': layout === 'PORCH', 'dense':denseMode, 'layout-public' : layout === 'PUBLIC'}"
      :style="{'background-image': backgroundImage}"
  >
    <div class="not-compatible-browser" v-if="browserNotCompatible">
      <i class="fa fa-times" @click="hideBrowserMessage"></i>
      <i class="fa fa-frown-o"></i><span v-html="$t('global.notCompatibleBrowser')"></span>
    </div>

    <Loading ref="loading"/>
    <Confirm ref="confirm"/>
    <Blocker v-if="blocker"/>
    <Messages ref="messages"/>

    <Modal
        ref="modal"
        :width="modalProps.width"
        :height="modalProps.height"
        :type="modalPropsType"
        :resetContent="modalProps.resetContent || false"
    >
      <span slot="header" v-html="modalProps.title"></span>
      <component slot="content" :is="modalComponent" :props="modalComponentProps"></component>
    </Modal>

    <!-- <Navbar v-if="layout === 'DEFAULT'" :class="{ blur: blur }" :acl="acl" /> -->
    <UiNavbar v-if="layout === 'DEFAULT'" :class="{ blur: blur }" :acl="acl" />

    <div
        v-if="layout === 'DEFAULT' && alertsToShow.length !== 0"
        class="alerts-container"
        v-can="'beepiz-browse-alerts'"
    >
      <div style="display: flex; justify-content: flex-end">
        <b-button v-if="alertsToShow.length > 6 && !alertHideAll" pill variant="danger"
                  style="margin-right: 219px">+{{ alertsToShow.length - 6 }}
        </b-button>
        <b-button v-if="alertsToShow.length > 0 && alertHideAll === false" pill variant="dark" style="margin-left: 7px"
                  @click="alertHideAll = true">
          <i class="fa fa-chevron-down" style="font-size: 10px"></i>
        </b-button>
        <b-button v-if="alertsToShow.length > 0 && alertHideAll === true" pill variant="danger"
                  style="height: 50px; width: 50px" @click="alertHideAll = false">
          <i class="fa fa-bell" style="font-size: 16px"></i>
        </b-button>
      </div>
      <div v-if="alertList.length !== 0 && !alertHideAll">
        <Alert
            v-for="alert in alertList"
            :key="alert.id"
            :alert="alert"
            @dismiss="handleDismiss"
            @maximize="handleMaximize"
            @hide="handleHide"
        />
      </div>
    </div>

    <section
      class="main-container bg-gray-50"
      :class="{ blur: blur }"
      v-if="layout !== 'PUBLIC'"
    >
      <router-view :key="$route.fullPath"></router-view>
    </section>

    <template v-if="layout === 'PORCH'">
      <div class="footer" v-if="isThemeSfr">
        &copy; 2025 SFR DATI - <a href="https://sfr.beepiz.com/" target="_blank">www.sfr.beepiz.com</a>
      </div>
      <div class="footer" v-else-if="isThemeCatsafe">
        &copy; 2025 CAT'SAFE - <a href="https://catsafe.beepiz.com/" target="_blank">www.catsafe.beepiz.com</a>
      </div>
      <div class="footer" v-else>
        &copy; 2025 BEEPIZ - <a href="http://www.beepiz.com" target="_blank">www.beepiz.com</a>
      </div>
      <div ref="httpcsBadge" class="httpcs-badge"></div>
    </template>

    <template v-if="layout === 'PUBLIC'">
      <router-view :key="$route.fullPath"></router-view>
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import Loading from "@/components/ui/Loading";
import UiNavbar from "@/components/ui/Navbar2";
import Messages from "@/components/ui/Messages";
import Confirm from "@/components/ui/Confirm";
import Modal from "@/components/ui/Modal";
import Alert from "@/components/alert/Alert";
import axios from 'axios';
import API from '@/services/API.js';
import Auth from '@/services/auth.js';
import {Howl} from 'howler';
import findIndex from 'lodash/findIndex';
import bowser from 'bowser';
import Utils from '@/services/utils.js'
import Blocker from '@/components/ui/Blocker'
import Globals from '@/services/globals.js'
import LanguageSelection from "@/components/language/LanguageSelection";
import {useDvFlagAccess} from "./services/featureFlag";

export default {
  components: {
    Loading,
    UiNavbar,
    Messages,
    Confirm,
    Modal,
    Alert,
    Blocker,
    LanguageSelection
  },
  name: 'app',
  data: () => ({
    backgrounds: [
      require('@/assets/img/login-bg1.jpg'),
      require('@/assets/img/login-bg2.jpg'),
      require('@/assets/img/login-bg3.jpg')
    ],
    blur: false,
    blocker: false,
    modalComponent: null,
    modalProps: {
      title: '',
      width: '100%',
      // height: '100%'
    },
    modalComponentProps: {},
    sound: null,
    browserNotCompatible: true,
    denseMode: false,
    alertsToShow: [],
    alertList6: [],
    alertShowAll: false,
    alertHideAll: false,
    isThemeSfr: Utils.isThemeSfr(),
    isThemeCatsafe: Utils.isThemeCatsafe(),
  }),
  mounted: function () {
    this.handleIcon()
    setTimeout(() => {
      this.checkForAlerts();
    }, 1000);
    setInterval(() => {
      this.checkForAlerts();
    }, 20000);
    setInterval(() => {
      var lsDenseMode = window.V.$localStorage.get('BPZ_' + Auth.getHash() + '_DENSE_MODE');
      var lsGlobalPerpage = window.V.$localStorage.get('BPZ_' + Auth.getHash() + '_GLOBAL_PER_PAGE');
      if (lsGlobalPerpage) {
        Globals.perPage = lsGlobalPerpage
      } else {
        Globals.perPage = 30
      }
      if (lsDenseMode !== '0') {
        this.denseMode = true;
        window.V.$localStorage.set('BPZ_' + Auth.getHash() + '_DENSE_MODE', 1)
      } else {
        this.denseMode = false;
      }
      Vue.prototype.$denseMode = this.denseMode
    }, 500);
    if (
        (sessionStorage.getItem("BEEPIZ_OLD_BROWSER") && sessionStorage.getItem("BEEPIZ_OLD_BROWSER") === 'false') ||
        (bowser.chrome && bowser.version >= 60) ||
        (bowser.firefox && bowser.version >= 55) ||
        (bowser.msedge && bowser.version >= 15) ||
        (bowser.opera && bowser.version >= 47) ||
        (bowser.safari)
    ) {
      this.browserNotCompatible = false;
    }
    if (this.layout === 'PORCH') {
      let script = document.createElement('script');
      script.setAttribute('type', "text/javascript");
      script.setAttribute('src', "https://www.httpcs.com/certified/js/59084/client.suivideflotte.net");
      script.setAttribute('async', true);
      script.setAttribute('defer', true);
      this.$refs.httpcsBadge.appendChild(script);
    }
  },
  computed: {
    acl() {
      return window.V.acl;
    },
    layout() {
      if (this.$route.meta.layout === 'public') {
        return 'PUBLIC';
      }
      if (!!window.V.loginMode) {
        return 'PORCH';
      }
      return 'DEFAULT';
    },
    backgroundImage: function () {
      if (this.layout === 'PORCH') {
        return 'url(' + this.backgrounds[Math.floor(Math.random() * (this.backgrounds.length - 0))] + ')';
      }
      return null;
    },
    modalPropsType: function () {
      if (this.modalProps.type != null) {
        return this.modalProps.type;
      }
      return null;
    },
    alertList() {
      let list = []
      if (this.alertsToShow.length >= 6) {
        for (let i = 1; i < 7; i++) {
          list.push(this.alertsToShow[this.alertsToShow.length - i])
        }
      } else {
        list = this.alertsToShow
      }
      return list
    }
  },
  watch: {
    alertsToShow: function (currentAlerts, oldAlerts) {
      if (currentAlerts.length === 0) {
        this.stopSound()
      } 

      // On déclenche le son au chargement s'il existe déjà des alertes, ou s'il y en a de nouvelles
      if (currentAlerts.length > 0 && currentAlerts.length > oldAlerts.length) {
        this.playSound()
      }
    }
  },
  methods: {
    handleIcon() {
      // accessing the link tag
      var icon = '';
      var url = window.location.href;
      const favicon = document.getElementById("favicon");

      if (Utils.isThemeSfr()) {
        icon = '/static/icons/sfr-favicon.png';
      } else if (Utils.isThemeCatsafe()) {
        icon = '/static/icons/catsafe-favicon.svg';
      } else {
        icon = '/static/icons/favicon.svg';
      }
      favicon.href = icon;
    },
    hideBrowserMessage: function () {
      this.browserNotCompatible = false;
      sessionStorage.setItem('BEEPIZ_OLD_BROWSER', this.browserNotCompatible);
    },
    blurMode: function (val) {
      this.blur = val || false;
    },
    checkForAlerts() {
      if (Auth.isLoggedIn() && useDvFlagAccess("beepiz-dashboard-alert-live-can:read")) {
        var lang = window.V.$localStorage.get('BPZ_' + Auth.getHash() + '_LOCALE')
        if (lang == null) {
          lang = 'fr'
        }
        var sound = '/sounds/alert-' + (Utils.getThemeName() !== 'default' ? Utils.getThemeName()+'-' : '')  + lang + '.mp3'

        if (!this.sound || (this.sound && !this.sound.playing())) {
          this.sound = new Howl({
            src: [sound],
            loop: window.V.$localStorage.get('BPZ_LOOP_ALERT_SOUND') === '1'
          });
        }
        axios.get(API.endpoints.alerts.index)
            .then(response => {
              this.alertsToShow = [];

              for (var aKey in response.data) {
                if (window.V.$localStorage.get('BPZ_' + Auth.getHash() + '_HIDE_ALERT_' + response.data[aKey].id) !== '1') {

                  this.alertsToShow.push(response.data[aKey]);

                  if (window.V.$localStorage.get('BPZ_' + Auth.getHash() + '_HIDE_ALERT_' + response.data[aKey].id) !== '0') {
                    if (window.Notification && Notification.permission === "granted") {
                      this.sendWebNotification(response.data[aKey]);
                    }
                    window.V.$localStorage.set('BPZ_' + Auth.getHash() + '_HIDE_ALERT_' + response.data[aKey].id, '0')
                  }
                }
              }
            })
      }
    },
    handleDismiss(alert) {
      setTimeout(() => {
        var index = findIndex(this.alertsToShow, function (item) {
          return item.id == alert.id
        });
        this.alertsToShow.splice(index, 1);
      }, 1000);
    },
    handleDismissAll() {
      this.alertsToShow.forEach(el => this.handleDismiss(el))
    },
    handleMaximize(alert) {},
    handleHide(alert) {},
    stopSound: function () {
      if (this.sound) {
        this.sound.stop()
      }
    },
    playSound: function () {
      const userWantSound = window.V.$localStorage.get('BPZ_' + Auth.getHash() + '_PLAY_ALERT_SOUND') === '1' ||
        window.V.$localStorage.get('BPZ_' + Auth.getHash() + '_PLAY_ALERT_SOUND') == null
      if (userWantSound && this.sound && !this.sound.playing()) {
        this.sound.play();
      }
    },
    sendWebNotification: function (alert) {
      var notification = new Notification(Utils.t('global.alert.notification.title'), {
        body: Utils.t('global.alert.notification.body1') + " \"" + alert.event_type_label + "\" " + Utils.t('global.alert.notification.body2') + " " + (alert.identification_name ? alert.identification_name + "(" + alert.dati_name + ")" : Utils.t('global.alert.notification.body3') + " " + alert.dati_name),
        tag: Utils.t('global.alert.notification.tag'),
        icon: 'data:image/png;base64,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'
      });
      notification.onclick = function () {
        window.focus();
        if (this.cancel) {
          this.cancel();
        }
      };
    },
    showBlocker(val) {
      this.blurMode(val)
      this.blocker = val
    }
  }
}
</script>

<style lang="scss">
@import './assets/scss/main.scss';
body.sfr {
  --colors-primary-50: var(--colors-red-50);
  --colors-primary-100: var(--colors-red-100);
  --colors-primary-200: var(--colors-red-200);
  --colors-primary-300: var(--colors-red-300);
  --colors-primary-400: var(--colors-red-400);
  --colors-primary-500: var(--colors-red-500);
  --colors-primary-600: var(--colors-red-600);
  --colors-primary-700: var(--colors-red-700);
  --colors-primary-800: var(--colors-red-800);
  --colors-primary-900: var(--colors-red-900);
  --colors-primary-950: var(--colors-red-950);
}
body.catsafe {
  --colors-primary-50: var(--colors-garfield-50);
  --colors-primary-100: var(--colors-garfield-100);
  --colors-primary-200: var(--colors-garfield-200);
  --colors-primary-300: var(--colors-garfield-300);
  --colors-primary-400: var(--colors-garfield-400);
  --colors-primary-500: var(--colors-garfield-500);
  --colors-primary-600: var(--colors-garfield-600);
  --colors-primary-700: var(--colors-garfield-700);
  --colors-primary-800: var(--colors-garfield-800);
  --colors-primary-900: var(--colors-garfield-900);
  --colors-primary-950: var(--colors-garfield-950);
}
</style>
